// Content for Śrīmad-Bhāgavatam 1.9.19 commentary topic

import type { TopicContent } from '../types';

const content: TopicContent = {
    primarySloka: {
        reference: 'Srimad Bhagavatam 1.9.19',
        sloka: `asyānubhāvaṁ bhagavān
veda guhyatamaṁ śivaḥ
devarṣir nāradaḥ sākṣād
bhagavān kapilo nṛpa`,
        translation:
            'O king (<strong>nṛpa</strong>)! Lord Śiva (<strong>śivaḥ</strong>), Nārada, sage of the heavens (<strong>devarṣir nāradaḥ</strong>), and Lord Kapila (<strong>sākṣād bhagavān kapilaḥ</strong>) know the most secret anubhāvas of Kṛṣṇa (<strong>asyānubhāvaṁ guhyatamaṁ</strong>), though not his intentions.',
    },
    blocks: [
        {
            type: 'text',
            content:
                '<strong>Śiva and others know particular actions of Kṛṣṇa-those actions he chooses to reveal to them (<em>anubhāvam</em>), but not his intentions, his real form or his real powers.</strong><br /><br />The knower of rasa-śāstras knows first of all anubhāvas and sāttvika-bhāvas-paralysis, perspiration, hair standing on end etc. By that he can understand the sthāyi-bhāva. By the particular qualities and intensity of the anubhāvas, he can understand the particular qualities and intensity of the sthāyi-bhāva.',
        },
        {
            type: 'text',
            content:
                'The knower of rasa-śāstra knows the anubhāva of Kṛṣṇa being tied by a rope by the gopīs like Yaśodā, and the dependent anubhāva of Kṛṣṇa being the charioteer for Arjuna, Yudhiṣṭhira and Ugrasena. These are anubhāvas of Kṛṣṇa indicating his dependence on others.<br /><br />The knower of rasa then infers that there exists something special in these cases which controls and melts the heart of even the Supreme Lord, the controller of all, the supremely independent entity.<br /><br /><strong>That object, which melts the hearts of the viṣaya and āśraya, which has many varieties, and which brings both parties under the control of the other is called prema. It is the crest jewel of all goals for the human being and is described by terms such as bhakti, sneha and anurāga.</strong>',
        },
        {
            type: 'text',
            content:
                'Seeing that Kṛṣṇa is controlled more when he sees his devotees, who generate prema in him, the knower of rasa infers that there is intense prema in the siddha and sādhaka devotees.<br /><br /><strong>He then concludes that the Kṛṣṇa is cause of difficulties for devotees, in order to increase their devotion to that level</strong>.<br /><br />Śiva, Nārada and Kapila know this. One sees an increase in prema in Draupadī and others when their difficulties increase.',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Srimad Bhagavatam 10.88.8',
                sloka: `yasyāham anugṛhṇāmi
hariṣye tad-dhanaṁ śanaiḥ
tato 'dhanaṁ tyajanty asya
svajanā duḥkha-duḥkhitam`,
                translation:
                    'If I especially favor someone, I gradually deprive him of his wealth. Then the relatives and friends of such a poverty-stricken man abandon him. In this way he suffers one distress after another.',
            },
        },
        {
            type: 'text',
            content:
                "<strong>Thus the difficulties the devotees experience are not prārabdha-karmas since they are given by the Lord alone, who wants to benefit the devotees.</strong><br /><br />However, this is not an inclusive rule. Sometimes the Lord increases his devotee's bhakti without giving problems to him. Thus it is said that no one knows the plan of the Lord.<br /><br />Śiva and Nārada know the anubhāvas or symptoms in the Lord. Other foolish people do not know the anubhāvas, like Kṛṣṇa allowing himself to be tied up.",
        },
        {
            type: 'text',
            content: '<strong>They explain it as some sort of fake display.</strong>',
        },
    ],
};

export default content;
